import React from 'react';

interface Props {
  className?: string;
}

const Split: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="19"
    viewBox="0 0 20 19"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      height="16"
      stroke="currentColor"
      strokeWidth="2"
      width="10"
      x="9"
      y="1.5"
    />
    <line
      stroke="currentColor"
      strokeDasharray="1 1"
      x1="9"
      x2="20"
      y1="10"
      y2="10"
    />
    <path
      d="M3.75 6.125C3.75 5.97726 3.7209 5.83097 3.66436 5.69448C3.60783 5.55799 3.52496 5.43397 3.4205 5.3295C3.31603 5.22504 3.19201 5.14217 3.05552 5.08564C2.91903 5.0291 2.77274 5 2.625 5C2.47726 5 2.33097 5.0291 2.19448 5.08564C2.05799 5.14217 1.93397 5.22504 1.8295 5.3295C1.72504 5.43397 1.64217 5.55799 1.58564 5.69448C1.5291 5.83097 1.5 5.97726 1.5 6.125C1.5 6.27274 1.5291 6.41903 1.58564 6.55552C1.64217 6.69201 1.72504 6.81603 1.8295 6.9205C1.93397 7.02496 2.05799 7.10783 2.19448 7.16436C2.33097 7.2209 2.47726 7.25 2.625 7.25C2.77274 7.25 2.91903 7.2209 3.05552 7.16436C3.19201 7.10783 3.31603 7.02496 3.4205 6.9205C3.52496 6.81603 3.60783 6.69201 3.66436 6.55552C3.7209 6.41903 3.75 6.27274 3.75 6.125ZM3.57422 8.57422C3.27891 8.68906 2.96016 8.75 2.625 8.75C1.17422 8.75 0 7.57578 0 6.125C0 4.67422 1.17422 3.5 2.625 3.5C4.07578 3.5 5.25 4.67422 5.25 6.125C5.25 6.46016 5.18672 6.77891 5.07422 7.07422L6 8L9.75 4.25H11.25L12 5L5.07422 11.9258C5.18906 12.2211 5.25 12.5398 5.25 12.875C5.25 14.3258 4.07578 15.5 2.625 15.5C1.17422 15.5 0 14.3258 0 12.875C0 11.4242 1.17422 10.25 2.625 10.25C2.96016 10.25 3.27891 10.3133 3.57422 10.4258L4.5 9.5L3.57422 8.57422ZM6.52969 11.5297L8.02969 10.0297L12 14L11.25 14.75H9.75L6.52969 11.5297ZM2.625 11.75C2.47726 11.75 2.33097 11.7791 2.19448 11.8356C2.05799 11.8922 1.93397 11.975 1.8295 12.0795C1.72504 12.184 1.64217 12.308 1.58564 12.4445C1.5291 12.581 1.5 12.7273 1.5 12.875C1.5 13.0227 1.5291 13.169 1.58564 13.3055C1.64217 13.442 1.72504 13.566 1.8295 13.6705C1.93397 13.775 2.05799 13.8578 2.19448 13.9144C2.33097 13.9709 2.47726 14 2.625 14C2.77274 14 2.91903 13.9709 3.05552 13.9144C3.19201 13.8578 3.31603 13.775 3.4205 13.6705C3.52496 13.566 3.60783 13.442 3.66436 13.3055C3.7209 13.169 3.75 13.0227 3.75 12.875C3.75 12.7273 3.7209 12.581 3.66436 12.4445C3.60783 12.308 3.52496 12.184 3.4205 12.0795C3.31603 11.975 3.19201 11.8922 3.05552 11.8356C2.91903 11.7791 2.77274 11.75 2.625 11.75Z"
      fill="currentColor"
    />
  </svg>
);

export default Split;
